import { Box, Flex, HStack, Stack } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import React from 'react';
import { Link } from 'react-router-dom';
import { useInboxModel } from '../../../../../common/models/InboxModel';
import { TextBlock } from '../../../common/components/TextBlock';
import { ROUTES } from '../../../config';

export const AlertList: React.FC = () => {
  const inboxModel = useInboxModel();
  const alertsCount = inboxModel.alerts.length;

  return (
    <Stack>
      <HStack gap="5px">
        <TextBlock weight="bold" fontSize="28px">
          Alerts
        </TextBlock>
        {alertsCount > 0 && (
          <TextBlock
            fontSize={'12px'}
            weight="bold"
            color="white"
            display="inline-flex"
            backgroundColor={'gray.300'}
            width="25px"
            height="25px"
            borderRadius={'50%'}
            alignItems={'center'}
            justifyContent={'center'}>
            {alertsCount}
          </TextBlock>
        )}
      </HStack>
      {inboxModel.alerts.length > 0 ? (
        inboxModel.alerts.map((alert, i) => {
          return (
            <Flex
              as={Link}
              to={ROUTES[alert.navigateTo] as string}
              mb={'10px'}
              flex={1}
              p={'24px'}
              borderWidth={'1px'}
              borderColor={'black'}
              key={`alert-${i}`}
              cursor={'pointer'}
              borderRadius={'10px'}
              _hover={{
                backgroundColor: 'gray.50',
                transition: 'all 0.2s ease-in-out',
              }}>
              <Icon color={'gray.600'} mr={'15px'} fontSize={'20px'} icon={alert.alertIcon} />
              <Box display="flex" flex={1}>
                <TextBlock weight="bold" color={'black'}>
                  {alert.title}
                </TextBlock>
              </Box>
              <Icon fontSize={'24px'} icon="chevron-right" />
            </Flex>
          );
        })
      ) : (
        <Flex
          borderWidth={'1px'}
          borderColor={'gray.500'}
          borderRadius={'10px'}
          direction="column"
          alignItems="center"
          p={'24px'}
          justifyContent="center">
          <TextBlock>No Alerts</TextBlock>
        </Flex>
      )}
    </Stack>
  );
};
